import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ThemeColorDirective } from 'src/app/core/utils/theme/theme-color.directive';
import { MaterialModule } from '../../modules/material/material.module';
import { LoadingBarComponent } from './loading-bar.component';
@NgModule({
  declarations: [LoadingBarComponent],
  imports: [CommonModule, MaterialModule, ThemeColorDirective],
  exports: [LoadingBarComponent],
})
export class LoadingBarModule {}
